module.exports = __webpack_public_path__ + "img/UP.80e9947d.svg";